import { clone } from "@bufbuild/protobuf"
import type { Dispatch, SetStateAction } from "react"
import React, { useCallback, useState } from "react"
import { useNavigate } from "react-router"
import { UserSchema } from "../../../proto/qf/types_pb"
import { hasEnrollment } from "../../Helpers"
import { useActions, useAppState } from "../../overmind"
import FormInput from "../forms/FormInput"

const ProfileForm = ({ children, setEditing }: { children: React.ReactNode, setEditing: Dispatch<SetStateAction<boolean>> }) => {
    const state = useAppState()
    const actions = useActions().global
    const navigate = useNavigate()

    // Create a copy of the user object, so that we can modify it without affecting the original object.
    const [user, setUser] = useState(clone(UserSchema, state.self))
    const [isValid, setIsValid] = useState(state.isValid)

    // Update the user object when user input changes, and update the state.
    const handleChange = useCallback((event: React.FormEvent<HTMLInputElement>) => {
        const { name, value } = event.currentTarget
        const updatedUser = clone(UserSchema, user)
        switch (name) {
            case "name":
                updatedUser.Name = value
                break
            case "email":
                updatedUser.Email = value
                break
            case "studentid":
                updatedUser.StudentID = value
                break
        }
        setUser(updatedUser)
        setIsValid(updatedUser.Name !== "" && updatedUser.Email !== "" && updatedUser.StudentID !== "")
    }, [user])


    // Sends the updated user object to the server on submit.
    const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        actions.updateUser(user)
        // Disable editing after submission
        setEditing(false)
        if (!hasEnrollment(state.enrollments)) {
            navigate("/courses")
        }
    }

    return (
        <div className="w-full">
            {!isValid ? children : null}
            <form className="space-y-4" onSubmit={submitHandler}>
                <FormInput prepend="Name" name="name" defaultValue={user.Name} onChange={handleChange} />
                <FormInput prepend="Email" name="email" defaultValue={user.Email} onChange={handleChange} type="email" />
                <FormInput prepend="Student ID" name="studentid" defaultValue={user.StudentID} onChange={handleChange} type="number" />
                <div className="flex gap-3 mt-6 pt-4 border-t border-base-300">
                    <button
                        className="btn btn-primary flex-1 gap-2"
                        disabled={!isValid}
                        type="submit"
                    >
                        <i className="fas fa-floppy-disk" />
                        Save Changes
                    </button>
                    {state.isValid && (
                        <button
                            className="btn btn-ghost"
                            type="button"
                            onClick={() => setEditing(false)}
                        >
                            Cancel
                        </button>
                    )}
                </div>
            </form>
        </div>
    )
}

export default ProfileForm
